module.exports = __webpack_public_path__ + "img/map.ad6caf41.png";